module.exports = __webpack_public_path__ + "static/media/sms2.670911dd.png";